import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { EmptyClassroom } from '@innovamat/glimmer-assets';
import { Typography } from '@innovamat/glimmer-components';

import { AddClassroomDropdown } from '../../../../components/add-classroom-dropdown';
import { useJoinToClassroom } from '../../join-to-classroom-context';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 24px;
`;

const SubtleText = styled(Typography.Body1)`
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
`;

function SelectGroupsEmptyState(): JSX.Element {
  const { t } = useTranslation();
  const { handleSuccessNewClassroom } = useJoinToClassroom();

  return (
    <Container>
      <EmptyClassroom />
      <div>
        <Typography.H4>
          {t('select-groups.select-groups.empty-state.title')}
        </Typography.H4>
        <SubtleText>
          {t('select-groups.select-groups.empty-state.description')}
        </SubtleText>
      </div>
      <AddClassroomDropdown
        options={['add-journey']}
        size="M"
        variant="accent"
        onSuccess={handleSuccessNewClassroom}
      />
    </Container>
  );
}

export { SelectGroupsEmptyState };
